import React, { useState } from "react";
// import { toast } from "react-toastify";
import { fetchWithAuth } from "../api/AuthApi.services";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;


const ReviewSection = ({ productId, accessToken, fetchComments, comments, formatDate, handleLoginClick, onCartError, onCartSuccess }) => {
  const [rating, setRating] = useState(0);
  const [newComment, setNewComment] = useState("");
  const [isPosting, setIsPosting] = useState(false);
  const [showAllComments, setShowAllComments] = useState(false);
  // const [popupMessage, setPopupMessage] = useState("");
  // const [showPopup, setShowPopup] = useState(false);
  const [editingReview, setEditingReview] = useState(null);

  // Get username from userDetails in localStorage
  const userDetails = localStorage.getItem("userDetails") ? JSON.parse(localStorage.getItem("userDetails")) : null;
  const username = userDetails ? userDetails.username : null;
  const userReview = comments.find(comment => comment.user === username);

  const handlePostReview = async (isEdit = false) => {
    if (!newComment.trim() && !rating) return;
    setIsPosting(true);

    try {
      const endpoint = isEdit
        ? `${API_BASE_URL}/product/comments/${editingReview ? editingReview.id : userReview.id}/`
        : `${API_BASE_URL}/product/${productId}/comments/`;

      const method = isEdit ? "PUT" : "POST";
      const body = {
        comment: newComment,
        rating: rating,
      };

      const response = await fetchWithAuth(endpoint, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        console.error("API Error Response:", data);
        if (data?.[0] && data[0].toLowerCase().includes("already commented")) {
          // setPopupMessage("You have already commented. Please edit your existing review.");
          onCartError("You have already commented. Please edit your existing review.");
          // setShowPopup(true);
          // setTimeout(() => setShowPopup(false), 2000);
          if (userReview) {
            setEditingReview(userReview);
            setNewComment(userReview.comment || "");
            setRating(parseFloat(userReview.rating) || 0);
          }
        } else {
          // setPopupMessage(data?.[0] || `Failed to ${isEdit ? "update" : "post"} review`);
          onCartError(data?.[0] || `Failed to ${isEdit ? "update" : "post"} review`);
          // setShowPopup(true);
          // setTimeout(() => setShowPopup(false), 2000);
        }
        return;
      }

      setNewComment("");
      setRating(0);
      setEditingReview(null);
      fetchComments();
      onCartSuccess(isEdit ? "Review updated successfully" : "Review posted successfully");
      // toast.success(isEdit ? "Review updated successfully" : "Review posted successfully");
    } catch (error) {
      console.error("Error during request:", error);
      // setPopupMessage("Something went wrong! Please try again.");
      onCartError("Something went wrong! Please try again.");
      // setShowPopup(true);
      // setTimeout(() => setShowPopup(false), 2000);
    } finally {
      setIsPosting(false);
    }
  };

  const handleEditReview = (comment) => {
    setEditingReview(comment);
    setNewComment(comment.comment || "");
    setRating(parseFloat(comment.rating) || 0);
  };

  const handleDeleteReview = async (commentId) => {
    try {
      setIsPosting(true);
      const endpoint = `${API_BASE_URL}/product/comments/${commentId}/`;
      const response = await fetchWithAuth(endpoint, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        const data = await response.json();
        // setPopupMessage(data?.[0] || "Failed to delete review");
        onCartError(data?.[0] || "Failed to delete review");
        // setShowPopup(true);
        // setTimeout(() => setShowPopup(false), 2000);
        return;
      }

      fetchComments();
      // toast.success("Review deleted successfully");
      onCartSuccess("Review deleted successfully");
    } catch (error) {
      // setPopupMessage("Something went wrong! Please try again.");
      // setShowPopup(true);
      // setTimeout(() => setShowPopup(false), 2000);
      onCartError("Something went wrong! Please try again.");
    } finally {
      setIsPosting(false);
    }
  };

  return (
    <div
      className="comments-section"
      style={{
        // backgroundColor: "#fff",
        padding: "20px",
        // border: "1px solid #e0e0e0",
        borderRadius: "4px",
      }}
    >
      {/* {showPopup && (
        <div
          className="popup-notification"
          style={{
            backgroundColor: "#f5f5f5",
            color: "#555",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #e0e0e0",
            marginBottom: "15px",
            textAlign: "center",
            fontSize: "14px",
          }}
        >
          {popupMessage}
        </div>
      )} */}

      <h3 style={{ color: "#212121", fontSize: "18px", fontWeight: "500", marginBottom: "20px" }}>
        Customer Reviews & Ratings
      </h3>

      {/* Existing Reviews */}
      {comments.length > 0 && (
        <div className="mt-3">
          {comments.slice(0, showAllComments ? comments.length : 5).map((comment, index) => (
            <div
              key={comment.id}
              className="comment d-flex mb-3"
              style={{
                backgroundColor: "#F0F6FD",
                padding: "15px",
                borderRadius: "15px",
              }}
            >
              <div
                className="comment-avatar"
                style={{
                  backgroundColor: "#2874f0",
                  color: "#fff",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "15px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                {comment.user.charAt(0).toUpperCase()}
              </div>
              <div className="comment-content flex-grow-1">
                <div className="comment-header d-flex justify-content-between align-items-center">
                  <div>
                    <strong style={{ color: "#2874f0", fontSize: "14px" }}>{comment.user}</strong>
                    <span
                      className="comment-time"
                      style={{ color: "#bbb", marginLeft: "10px", fontSize: "12px" }}
                    >
                      {formatDate(comment.created_at)}
                    </span>
                  </div>
                  {username && comment.user === username && !editingReview && (
                    <span style={{ fontSize: "12px", color: "#2874f0" }}>
                      <span
                        onClick={() => handleEditReview(comment)}
                        style={{
                          marginRight: "5px",
                          cursor: "pointer",
                          textDecoration: "none",
                        }}
                        onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
                        onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
                      >
                        Edit
                      </span>
                      <span style={{ margin: "0 5px" }}>|</span>
                      <span
                        onClick={() => handleDeleteReview(comment.id)}
                        style={{
                          cursor: "pointer",
                          textDecoration: "none",
                        }}
                        onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
                        onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
                      >
                        Delete
                      </span>
                    </span>
                  )}
                </div>
                <div className="stars" style={{ margin: "5px 0" }}>
                  {[...Array(5)].map((_, starIndex) => (
                    <span
                      key={starIndex}
                      style={{
                        color: starIndex < Math.round(parseFloat(comment.rating) || 0) ? "#388e3c" : "#757575",
                        fontSize: "14px",
                      }}
                    >
                      ★
                    </span>
                  ))}
                </div>
                <p style={{ color: "black", fontSize: "14px", margin: "5px 0 0 0" }}>{comment.comment}</p>
              </div>
            </div>
          ))}
          {comments.length > 5 && (
            <button
              className="btn btn-link"
              onClick={() => setShowAllComments(!showAllComments)}
              style={{
                color: "#2874f0",
                fontSize: "14px",
                padding: "5px 0",
                textDecoration: "none",
              }}
              onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
              onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
            >
              {showAllComments ? "Show Less" : "Show More"}
            </button>
          )}
        </div>
      )}

      {/* Review Form */}
      {!accessToken ? (
        <button className="btn btn-orange mt-3"  onClick={handleLoginClick}>
          Login to Review
        </button>
      ) : (
        <div
          className="add-review mt-4"
          style={{
            backgroundColor: "#fff",
            padding: "15px",
            border: "1px solid #e0e0e0",
            borderRadius: "4px",
          }}
        >
          <h5 style={{ color: "#212121", fontSize: "16px", marginBottom: "15px" }}>
            {editingReview ? "Edit Your Review" : "Add Your Review"}
          </h5>
          <div className="rating mb-3">
            {[1, 2, 3, 4, 5].map((star) => (
              <span
                key={star}
                style={{
                  color: rating >= star ? "#388e3c" : "#e0e0e0",
                  cursor: "pointer",
                  fontSize: "20px",
                  marginRight: "5px",
                }}
                onClick={() => setRating(star)}
              >
                ★
              </span>
            ))}
          </div>
          <textarea
            className="form-control mb-2"
            placeholder="Write your review..."
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            style={{
              backgroundColor: "#fff",
              color: "#333",
              border: "1px solid #e0e0e0",
              borderRadius: "0",
              fontSize: "14px",
              padding: "10px",
              minHeight: "80px",
            }}
          />
          <button
            className="btn btn-orange"
            onClick={() => handlePostReview(!!editingReview)}
            disabled={isPosting || (!newComment.trim() && !rating)}
          >
            {isPosting ? "Posting..." : editingReview ? "Update Review" : "Post Review"}
          </button>
        </div>
      )}
    </div>
  );
};

export default ReviewSection;